import { Select } from "antd";
import styled from "styled-components";

export const FilterByTag = styled(Select)`
  .ant-select-selector {
    border: 1px solid rgba(8, 10, 37, 0.1) !important;
    border-radius: 8px !important;
  }
`;